import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchManageOutsOrders } from './fetchManageOutsOrders';
import { fetchAuditTrailLogs } from './fetchAuditTrailLogs';
import { resetManageOutsData } from './resetManageOutsData';
import { fetchManageOutsStateCompare } from './fetchManageOutsStateCompare';
import { useExportHistorySearch } from './exportHistorySearch';
import { useExportManageOutsHistoryTrack as useExportManageOutsHistoryTrackHook } from './exportHistoryTrack';

export function useFetchManageOutsOrders() {
  const dispatch = useDispatch();
  return {
    fetchManageOutsOrders: useCallback((...args) => dispatch(fetchManageOutsOrders(...args)), [dispatch]),
  };
}

export function useFetchAuditTrailLogs() {
  const dispatch = useDispatch();
  return {
    fetchAuditTrailLogs: useCallback((...args) => dispatch(fetchAuditTrailLogs(...args)), [dispatch]),
  };
}

export function useResetManageOutsData() {
  const dispatch = useDispatch();
  return {
    resetManageOutsData: useCallback(() => dispatch(resetManageOutsData()), [dispatch]),
  };
}

export function useFetchManageOutsStateCompare() {
  const dispatch = useDispatch();
  return {
    fetchManageOutsStateCompare: useCallback((...args) => dispatch(fetchManageOutsStateCompare(...args)), [dispatch]),
  };
}

export function useExportManageOutsHistorySearch() {
  return useExportHistorySearch();
}

export function useExportManageOutsHistoryTrack() {
  return useExportManageOutsHistoryTrackHook();
}